var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"store-in"},_vm._l((_vm.list),function(item){return _c('list',{key:item,attrs:{"good":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }